<salon-finder-outlet-form [formModel]="outletForm"></salon-finder-outlet-form>